import {WorkflowExecution} from "@/types/workflow";

export const renderStatusBadge = (status: WorkflowExecution['status']) => {
    const statusConfig = {
        pending: {
            bgColor: 'bg-yellow-100 dark:bg-yellow-900/30',
            textColor: 'text-yellow-800 dark:text-yellow-400',
            label: 'Pending'
        },
        running: {
            bgColor: 'bg-blue-100 dark:bg-blue-800/30',
            textColor: 'text-blue-800 dark:text-blue-400',
            label: 'Running'
        },
        completed: {
            bgColor: 'bg-green-100 dark:bg-green-800/30',
            textColor: 'text-green-800 dark:text-green-400',
            label: 'Completed'
        },
        failed: {
            bgColor: 'bg-red-100 dark:bg-red-800/30',
            textColor: 'text-red-800 dark:text-red-400',
            label: 'Failed'
        }
    };

    const config = statusConfig[status];

    return (
        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor}`}>
                {config.label}
            </span>
    );
};
